import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import "./Nav.scss";

class Nav extends Component {
  constructor() {
    super();
  }

  componentDidMount() {
    window.addEventListener("scroll", () => {
      const isTop = window.scrollY < 70;
      const nav = document.getElementById("nav");
      if (isTop !== true) {
        nav.classList.add("scrolled");
      } else {
        nav.classList.remove("scrolled");
      }
    });
  }

  componentWillUnmount() {
    window.removeEventListener("scroll");
  }
  toggle = () => {
    var nav = document.querySelector(".nav");
    nav.classList.toggle("active"); 
  };
  render() {
    return (
      <div id="nav" className="nav">
        <div className="logo">
          <NavLink to="/" exact>
            <img src={require("../../images/logo logi.png")} alt="" />
          </NavLink>
        </div>
        <div className="nav-links">
          <NavLink to="/" exact onClick={this.toggle} activeClassName="active">
            Home
          </NavLink>
          <NavLink to="/courses" onClick={this.toggle} activeClassName="active">
            Courses
          </NavLink>
          {/* <NavLink to = '/career' activeClassName="active">Career</NavLink> */}
          <NavLink to="/about" onClick={this.toggle} activeClassName="active">
            About us
          </NavLink>
          <NavLink to="/contact" onClick={this.toggle} activeClassName="active">
            Contact us
          </NavLink>
        </div>
        <div className="toggle" onClick={this.toggle}></div>
      </div>
    );
  }
}

export default Nav;
